import Paper from "@assets/icons/paper.svg";
import instagramIcon from "@assets/icons/new-instagram.svg";
import facebookIcon from "@assets/icons/new-facebook.svg";
import mailIcon from "@assets/icons/new-mail.svg";
import youtubeIcon from "@assets/icons/new-youtube.svg";
import pinterestIcon from "@assets/icons/new-pinterest.svg";
import bfNlLogo from "@assets/logos/bf-nl.svg";
import FavIconNetherlands from "@assets/favicons/favicon-bf-nl.png";
import CheckmarkIcon from "@assets/icons/usp-check-mark.svg";

import { IPlatformSpecificInfo } from "../platform";

export const netherlandsPlatform: IPlatformSpecificInfo = {
  id: 1,
  currency: "EUR",
  name: "Black Friday Nederland",
  abbreviation: "nl",
  country: "Nederland",
  domain: "blackfridaynederland.nl",
  merchantOverviewLink: "/winkels/",
  dealOverviewLink: "/deals/",
  urlAddition: "",
  isLandingPage: false,
  defaultBackButtonText: "Terug",
  breadcrumbHomeName: "Home",
  breadcrumbHomeUrl: "/",
  readingTimeText: {
    singular: "minuut leestijd",
    plural: "minuten leestijd"
  },
  newsletterButtonTitle: "Aanmelden",
  newsletterModalTitle: "Inschrijven nieuwsbrief",
  fallBackHeaderImage: "https://media.blackfridaynederland.nl/wordpress/20200430114414/default-blog-image-nl.jpg",
  bottomFooter: {
    items: [
      {
        title: "Partner worden?",
        url: "/adverteren/"
      },
      {
        title: "Privacy",
        url: "/privacybeleid/"
      },
      {
        title: "Cookiebeleid",
        url: "/cookiebeleid/"
      },
      {
        title: "Sitemap",
        url: "/sitemap/"
      }
    ],
    logo: {
      src: bfNlLogo,
      alt: "Black Friday Logo",
      title: "Black Friday Logo"
    },
    logoLink: "/"
  },
  middleFooter: {
    links: [
      {
        id: "TRENDING_BLOCK",
        title: "Meer over Black Friday",
        links: []
      },
      {
        id: "SHOPS_BLOCK",
        title: "Meest bekeken pagina's",
        links: []
      },
      {
        id: "THIRD_BLOCK",
        title: "Winkels met de beste deals",
        links: []
      }
    ],
    newsletter: {
      title: "Meld je aan voor de nieuwsbrief",
      text: "En ontvang de allerbeste deals",
      buttonText: "Nieuwsbrief",
      buttonIcon: Paper
    },
    googleReviews: {
      link: {
        url: "https://www.feedbackcompany.com/nl-nl/reviews/black-friday-nederland",
        title: "Feedback Company Reviews"
      },
      rating: 4.5
    },
    socialMedia: {
      id: "SOCIAL_BLOCK",
      title: "Wil je ons volgen?",
      socialItem: [
        {
          image: {
            src: facebookIcon,
            alt: "Facebook Icon",
            title: "Facebook Icon"
          },
          link: "https://www.facebook.com/BlackFridayNederland/"
        },
        {
          image: {
            src: instagramIcon,
            alt: "Instagram Icon",
            title: "Instagram Icon"
          },
          link: "https://www.instagram.com/blackfridaynl/"
        },
        {
          link: "mailto:info@blackfridaynederland.nl",
          image: {
            src: mailIcon,
            alt: "Mail Icon",
            title: "Mail Icon"
          }
        },
        {
          link: "https://www.youtube.com/channel/UCr67Ko-t42y_vhifzjDP26A",
          image: {
            src: youtubeIcon,
            alt: "Youtube Icon",
            title: "Youtube Icon"
          }
        },
        {
          link: "https://nl.pinterest.com/BlackFridayNederland/",
          image: {
            src: pinterestIcon,
            alt: "Pinterest icon",
            title: "Pinterest Icon"
          }
        }
      ]
    }
  },
  fallbackMerchantHeader: {
    src: "https://media.blackfridaynederland.nl/wordpress/20200421102650/Black-Friday-Winkels-Nederland.jpg",
    alt: "Winkel header",
    title: "Header winkelpagina"
  },
  logo: {
    src: bfNlLogo,
    alt: "Black Friday Logo",
    title: "Black Friday Logo"
  },
  uspModule: {
    uniqueSellingPoints: [
      {
        icon: CheckmarkIcon,
        link: {
          url: "/winkels/",
          title: "Alle acties in één overzicht"
        }
      },
      {
        icon: CheckmarkIcon,
        link: {
          url: "/deals/",
          title: "Scoor gemakkelijk de beste deals"
        }
      },
      {
        icon: CheckmarkIcon,
        link: {
          url: "/nieuwsbrief/",
          title: "Mis niets van Black Friday"
        }
      }
    ]
  },
  storeTabs: [
    {
      href: "/winkels/",
      title: "Winkels",
      isSelected: true
    },
    {
      href: "/deals/",
      title: "Deals"
    }
  ],
  dealTabs: [
    {
      href: "/winkels/",
      title: "Winkels"
    },
    {
      href: "/deals/",
      title: "Deals",
      isSelected: true
    }
  ],
  locale: "nl-NL",
  tagManagerScriptLocation: "/static/googletagmanager-nl-nl.js",
  favIcon: FavIconNetherlands,
  favIconPublic: "https://media.blackfridaynederland.nl/static/FavIcons/favicon-bf-nl.png",
  gtm: "GTM-5JMPWC4",
  enableDealAlerts: true,
  isOffline: false
};
